import { BaseModel } from "~/model"
import { DateModel } from "~/model"

export class InterventionPlanningModel extends BaseModel {
    static primaryKey = "IDINTERVENTION_PLANNING"

    get titleDate() {
        const difference = DateModel.formatDifference(
            this.RDV_DEBUT,
            this.RDV_FIN,
        )

        const date = DateModel.formatCompleteDay(this.RDV_DEBUT)
        const hour = DateModel.formatTime(this.RDV_DEBUT)

        return `${date} <b>${hour}</b> (${difference})`
    }
}
